import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
import { AppModule } from '../app.module';
import { SharedDataService } from '../shared/shareddata.service';
import { WhatsappService } from './whatsapp.service';
import { WAConversation } from "./wa-conversation/wa-conversation";

@Component({
  selector: 'app-whatsapp',
  imports: [AppModule, WAConversation],
  templateUrl: './whatsapp.html',
  styleUrl: './whatsapp.less'
})
export class Whatsapp implements OnInit, OnDestroy {

  incidentId: number | null = null;

  private historySubscription?: Subscription;

  constructor(public sharedDataService: SharedDataService, public whatsappService: WhatsappService, private authService: AuthService) {
    effect(() => {
      const incidentId = this.whatsappService.currentIncidentId();
      console.log("Incident ID in Whatsapp component: ", incidentId);
      this.incidentId = incidentId;
    });



   }

  ngOnInit(): void {
    if (this.authService.user?.userId) {
      this.historySubscription = this.whatsappService.loadOpenMessages(this.authService.user.userId);
    }
  }

  ngOnDestroy(): void {
    this.historySubscription?.unsubscribe();
  }
}
